import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["active", "children", "disabled", "icon", "onClick", "tooltip", "tooltipPlacement"];
import { PureComponent } from 'react';
import UITextToolbarButton from 'rich-text-lib/components/editor/UITextToolbarButton';
import { TextToolbarIcon } from 'rich-text-lib/components/editor/TextToolbarIcon';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { AttachIcon, InsertImageIcon, InsertVideoIcon } from 'foundations-assets';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
// temporary until consumer components can be patched to use icon components
const supportedIconStrings = {
  attach: AttachIcon,
  insertVideo: InsertVideoIcon,
  insertImage: InsertImageIcon
};
export default class SmallToggleButton extends PureComponent {
  render() {
    const _this$props = this.props,
      {
        active,
        children,
        disabled = false,
        icon: iconComponentOrString,
        onClick,
        tooltip,
        tooltipPlacement = 'top'
      } = _this$props,
      rest = _objectWithoutPropertiesLoose(_this$props, _excluded);
    const IconComponent = typeof iconComponentOrString === 'string' ? supportedIconStrings[iconComponentOrString] : iconComponentOrString;
    const shouldForceTooltipClosed = disabled || active;
    return /*#__PURE__*/_jsx(Tooltip, {
      open: shouldForceTooltipClosed ? false : undefined,
      title: tooltip,
      placement: tooltipPlacement,
      marginInline: "100",
      children: /*#__PURE__*/_jsxs(UITextToolbarButton, Object.assign({
        disabled: disabled,
        onSelectedChange: onClick,
        selected: active
      }, rest, {
        children: [children, IconComponent && /*#__PURE__*/_jsx(TextToolbarIcon, {
          disabled: disabled,
          icon: IconComponent
        })]
      }))
    });
  }
}